module.exports = __webpack_public_path__ + "media/images/icons/icon_money-151e887866021d33e714d9f06cd07ca4.svg";